import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import classNames from 'classnames';
import I18n from 'PMT/i18n/I18n';

// -- entities
import { OrderSettings } from 'PMT/entities/order';

// -- components
import Switch from 'react-bootstrap-switch';
import { PhonesList, EmailsList } from 'PMT/components/form';

import TipTooltip from 'PMT/components/TipTooltip';

import SecurityContext from 'utils/permissions/SecurityContext';

export default class OrderNotificationSettingsView extends Component {
  static propTypes = {
    orderSettings: PropTypes.objectOf(OrderSettings).isRequired,

    /**
     * @param OrderSettings
     */
    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool.isRequired,
  };

  //
  //  events
  //

  onTogglePhoneNotification = () => {
    const orderSettings: OrderSettings = this.props.orderSettings;
    orderSettings.notificationSettings.phoneEnabled = !orderSettings
      .notificationSettings.phoneEnabled;
    this.props.onChange(orderSettings);
  };

  onToggleEmailNotification = () => {
    const orderSettings: OrderSettings = this.props.orderSettings;
    orderSettings.notificationSettings.emailEnabled = !orderSettings
      .notificationSettings.emailEnabled;
    this.props.onChange(orderSettings);
  };

  onNotificationSettingsPhonesChange = (phonesList) => {
    const orderSettings: OrderSettings = this.props.orderSettings;
    orderSettings.notificationSettings.phones = phonesList;
    this.props.onChange(orderSettings);
  };

  onEmailsChange = (emailsList) => {
    const orderSettings: OrderSettings = this.props.orderSettings;
    orderSettings.notificationSettings.emails = emailsList;
    this.props.onChange(orderSettings);
  };

  //
  // renderers
  //

  renderNotificationsSettings() {
    return (
      <div className="top-buffer-20">
        <div className="row">
          <div className="col-xs-12">
            <p>
              {I18n.tr('order.settings.notifications.sms_email')}
              <TipTooltip
                text={I18n.tr('order.settings.notifications.sms_email_tooltip')}
              />
            </p>
          </div>
        </div>

        {/* SMS */}
        {SecurityContext.admin.isAdmin() && (
          <div className="row top-buffer-20">
            <div className="row col-sm-offset-2 col-xs-12 col-sm-4">
              <div className="col-xs-4">
                <p>{I18n.tr('global.sms')}</p>
              </div>
              <div className="col-xs-2">
                {/* force re-render when state change with key=. Otherwise infinite loop */}
                <Switch
                  key={`${
                    this.props.orderSettings.notificationSettings.phoneEnabled
                  }_${Math.random()}`}
                  bsSize="mini"
                  value={
                    this.props.orderSettings.notificationSettings.phoneEnabled
                  }
                  onChange={this.onTogglePhoneNotification}
                  disabled={this.props.readOnly}
                />
              </div>
            </div>

            <div className="col-xs-12 col-sm-6 col-lg-3">
              <PhonesList
                list={this.props.orderSettings.notificationSettings.phones}
                onChange={this.onNotificationSettingsPhonesChange}
                disabled={this.props.readOnly}
              />
            </div>
          </div>
        )}

        {/* EMAIL */}
        <div className="row top-buffer-20">
          <div className="row col-sm-offset-2 col-xs-12 col-sm-4">
            <div className="col-xs-4">
              <p>{I18n.tr('global.email')}</p>
            </div>
            <div className="col-xs-2">
              {/* force re-render when state change with key=. Otherwise infinite loop */}
              <Switch
                key={`${
                  this.props.orderSettings.notificationSettings.emailEnabled
                }_${Math.random()}`}
                bsSize="mini"
                value={
                  this.props.orderSettings.notificationSettings.emailEnabled
                }
                onChange={this.onToggleEmailNotification}
                disabled={this.props.readOnly}
              />
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-3">
            <EmailsList
              list={this.props.orderSettings.notificationSettings.emails}
              onChange={this.onEmailsChange}
              disabled={this.props.readOnly}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    try {
      return <div className="">{this.renderNotificationsSettings()}</div>;
    } catch (e) {
      console.error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/order/settings/components/OrderNotificationSettingsView.js